export function formatCustomerCodeInput(text) {
  return String(text ?? '').replace(/\D/g, '').slice(0, 10)
}

export function isValidCustomerCode(value) {
  return /^9\d{9}$/.test(formatCustomerCodeInput(value))
}
